import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { message, Select, Table, TableProps } from "antd";
import Spinner from "../../components/shared/Spinner/Spinner";
import {
  OrderStatusType,
  ProductOrderssDataType,
} from "../../interfaces/admin.interface";
import { OrdersService } from "../../services/orders.service";
import { formatDate } from "../../extentions/date";
import ShowImage from "../../components/shared/show-image/ShowImage";
import { OrderStatusService } from "../../services/order_status.service";
import MainButton from "../../components/shared/MainButton/MainButton";
import { MdFileDownload } from "react-icons/md";
import { ExcelDowloadServices } from "../../services/downloadExcell.service";
const AccessoryOrders = () => {
  const [orders, setOrders] = useState<ProductOrderssDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [showImageModal, setShowImageModal] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string>("");
  const [status, setStatus] = useState<OrderStatusType[]>([]);
  useEffect(() => {
    setLoading(true);
    OrdersService.getAccessoryOrders()
      .then((response) => {
        if (Array.isArray(response?.data?.data)) {
          const dataWithKeys = response?.data?.data?.map(
            (item: ProductOrderssDataType, index: number) => ({
              ...item,
              key: index + 1,
            })
          );
          setOrders(dataWithKeys);
          console.log(response?.data.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    OrderStatusService.getAllStatus().then((response) => {
      if (Array.isArray(response?.data?.data)) {
        setStatus(response?.data?.data);
      }
    });
  }, []);

  const handleChangeStatus = async (orderId: number, statusId: number) => {
    try {
      const response = await OrdersService.changeAccessoryOrderStatus(
        orderId,
        statusId
      );
      if (response.status === 200) {
        const updatedOrders = orders.map((order) =>
          order.id === orderId
            ? {
                ...order,
                status: {
                  ...order.status,
                  id: statusId,
                  name: status.find((s) => s.id === statusId)?.name || "",
                },
              }
            : order
        );
        setOrders(updatedOrders);
        message.success(response.data.message);
      }
    } catch (error: any) {
      message.error(error.response.data.message);
    }
  };

  const columns: TableProps<ProductOrderssDataType>["columns"] = [
    {
      title: "№",
      dataIndex: "key",
      sorter: (a, b) => a.key - b.key,
    },
    {
      title: "Sifariş kodu",
      dataIndex: "order_code",
    },
    {
      title: "Müştəri",
      dataIndex: "full_name",
      sorter: (a, b) => a.full_name.localeCompare(b.full_name),
    },

    {
      title: "Nömrə",
      dataIndex: "number",
      render: (_, record) => (
        <a
          className="content"
          href={`tel:${record.number_prefix}${record.number}`}
        >
          {record.number_prefix} {record.number}
        </a>
      ),
    },
    {
      title: "Ünvan",
      dataIndex: "address",
    },
    {
      title: "Cihazın modeli",
      dataIndex: "model_number",
    },
    {
      title: "Qeyd",
      dataIndex: "note",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, record) => (
        <div style={{ padding: "0 20px" }}>
          <Select
            value={record.status.id}
            style={{ width: "100%" }}
            options={status.map((el) => ({
              label: el.name,
              value: el.id,
            }))}
            onChange={(value) => handleChangeStatus(record.id, value)}
          />
        </div>
      ),
    },
    //  {
    //     title: "Qeyd",
    //     dataIndex: "model_number",
    //   },
    {
      title: "Ləğv edilmə səbəbi",
      dataIndex: "reason",
      render: (_, record) => <p className="status">{record?.reason}</p>,
    },
    {
      title: "Məhsulun şəkili",
      dataIndex: "image",
      render: (_, record) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            setSelectedImage(record.image!);
            setShowImageModal(true);
          }}
        >
          {record.image ? (
            <img style={{ width: "100px" }} src={record.image} alt="" />
          ) : null}
        </div>
      ),
    },
    {
      title: "Sifariş tarixi",
      dataIndex: "created_at",
      render: (_, record) => <p>{record.created_at}</p>,
    },
    {
      title: "E-poçt",
      dataIndex: "email",
      sorter: (a, b) => a.user.email.localeCompare(b.email),
      render: (_, record) => (
        <a className="content" href={`mailto:${record.email}`}>
          {record.email}
        </a>
      ),
    },
  ];
  const handleDownload = async () => {
    try {
      const res = await ExcelDowloadServices.getAccesoryExcell();
      const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "accessory_orders.xls");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {}
  };

  return (
    <div id="pages">
      <Helmet>
        <title>1412 | Aksesuar sifarişləri</title>
      </Helmet>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          <div className="page_head">
            <h3 className="page_title"> Aksesuar sifarişləri</h3>
          </div>
          <div className="pages_components">
            <MainButton onClick={handleDownload}>
              <MdFileDownload size={25} />
            </MainButton>
            <div className="pages_table">
              <Table
                scroll={{ x: "100%" }}
                columns={columns}
                dataSource={orders}
                rowKey={(record) => record.id.toString()}
                pagination={false}
              />
            </div>
          </div>
        </div>
      )}
      <ShowImage
        showImageModal={showImageModal}
        setShowImagesModal={setShowImageModal}
        image={selectedImage}
      />
    </div>
  );
};

export default AccessoryOrders;
